<template>
  <DatatableReportV3
    id="invoices-table"
    ref="invoices_datatable"
    title="Invoices"
    class="no-cursor"
    :config="config"
    :source="source"
    :filters="filters"
    :map-records="applyFilter"
    subpage
    :flat="flat"
    no-download
    :min-height="400"
  >
    <template #column-invoice="row">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span @click="viewInvoice(row, $event)" v-html="row.columnValue"></span>
    </template>
    <template #actions>
      <slot name="actions"></slot>
    </template>
  </DatatableReportV3>
</template>

<script>
import Badge from "@/components/Badge.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    flat: {
      type: Boolean,
      default: false
    },
    address: {
      type: Object,
      default: null
    },
    filters: {
      type: Array,
      default: () => []
    },
    source: {
      type: String,
      default: ""
    },
    customerId: {
      type: Number,
      default: null
    },
    showSubCustomers: {
      type: Boolean,
      default: false
    }
  },
  emits: ["view-invoice"],
  data() {
    return {
      config: {
        order: [[0, "desc"]],
        columns: [
          {
            data: "completed_on",
            title: "Date"
          },
          { data: "invoice" },
          {
            data: "last_sent_badge",
            title: "Sent",
            orderable: false,
            searchable: false,
            className: "invoice-sent-badge"
          },
          { data: "job" },
          {
            data: "customer",
            title: "Customer",
            orderable: false,
            visible: this.showSubCustomers,
            filterName: "customer_id"
          },
          {
            data: "location_name",
            title: "Location Name",
            orderable: false,
            visible: !this.address
          },
          {
            data: "service_address",
            title: "Service Address",
            orderable: false,
            visible: !this.address
          },
          {
            data: "total",
            title: "Invoice Total",
            className: "text-right",
            searchable: false
          },
          {
            data: "balance",
            title: "Balance Due",
            className: "text-right",
            searchable: false,
            createdCell: function (td, cellData) {
              if (cellData !== "--") {
                $(td).addClass("text-danger");
              }
            }
          },
          { data: "batch_date", title: "Batch Date" }
        ],
        vueComponents: [
          {
            rootId: "badge-vue",
            component: Badge
          }
        ]
      }
    };
  },
  methods: {
    applyFilter(record) {
      record.customer_id = this.customerId;
      return record;
    },
    viewInvoice(row, e) {
      e.preventDefault();
      this.$emit("view-invoice", row.DT_RowId);
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.invoice-sent-badge) {
  max-width: 100px;
  .sera-badge {
    margin-left: 0px;
    justify-content: center !important;
    max-width: 75px;
  }
}
</style>
